var React = require('react');

function Cancer (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 32C12 23 20.3333 2 11 2C1.66667 2 12 26 21 32","stroke":"#34363E","strokeWidth":"3"}));
}

Cancer.defaultProps = {"width":"22","height":"34","viewBox":"0 0 22 34","fill":"none"};

module.exports = Cancer;

Cancer.default = Cancer;
